import {AfterViewInit, Component, ElementRef, inject, Input, ViewChild} from '@angular/core';
import {BaseRecordTableItemComponent} from "../base-record-table-item/base-record-table-item.component";
import {DateAdapter, provideNativeDateAdapter} from "@angular/material/core";
import {switchTimeFormats} from "./configs/time-transform";
import {UtilityService} from "../../../../services/utility.service";
import {ErrorService} from "../../../../services/error.service";
import {CustomTimeAdapter} from "../../../../adapters/custom-time.adapter";
import {MatTimepicker} from "@angular/material/timepicker";

@Component({
  selector: 'app-time-record-table-item',
  standalone: false,
  templateUrl: './time-record-table-item.component.html',
  styleUrls: [
    '../base-record-table-item-styles.scss',
    './time-record-table-item.component.scss'
  ],
  providers: [
    provideNativeDateAdapter(),
    { provide: DateAdapter, useClass: CustomTimeAdapter }
  ]
})
export class TimeRecordTableItemComponent extends BaseRecordTableItemComponent implements AfterViewInit {
  @Input({ transform: switchTimeFormats }) override value!: string;
  @ViewChild('timeInput') timeInput!: ElementRef<HTMLInputElement>;

  private errorService: ErrorService = inject(ErrorService);
  private utilityService: UtilityService = inject(UtilityService);

  public defaultValue: Date | null = null;

  public ngAfterViewInit(): void {
    this.defaultValue = new Date(this.value);
  }

  public handleInputChange(event: Event, picker: MatTimepicker<any>): void {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = this.validationService.processTimeInput(inputElement.value);
    inputElement.value = inputValue;

    if (/^\d{1,2}:\d{2}$/.test(inputValue)) {
      const [hours, minutes] = inputValue.split(':').map(Number);

      if (hours > 23 || minutes > 59) {
        inputElement.value = this.resetTime(picker);
        this.errorService.showErrorMessage('Некорректное время');
      }
    }
  }

  public handleDateInputChange(event: Event, picker: MatTimepicker<any>): void {
    const formattedDate = this.value ? this.utilityService.dateToTimeString(new Date(this.value)) : null;
    const [ hours, minutes ] = formattedDate?.split(':') || [];
    if (isNaN(Number(hours)) && isNaN(Number(minutes))) {
      (event.target as HTMLInputElement).value = this.resetTime(picker);
      super.handleValueChange(null);
      return;
    }

    super.handleValueChange(formattedDate);
  }

  private resetTime(picker: MatTimepicker<any>): string {
    this.timeInput.nativeElement.blur();
    picker.close();
    return '';
  }
}
